import { createContext, useCallback } from 'react'

export type PrintContextType = {
  print?: () => void
}

export const PrintContext = createContext<PrintContextType>({
  print: undefined
})

export const usePrint = () => {
  const handlePrint = useCallback(() => {
    window.print()
  }, [])

  return { handlePrint }
}
